import { Container, injectable } from 'inversify'
import 'reflect-metadata'

import { watch } from 'vue';


import MyApolloClient from '../../../../common/infrastructure/funciones/HelperApolloClient';
import { IComponentAttributeEventRepository } from '../domain/IComponentAttributeEventRepository';

import { UPDATE, ADD } from './mutation/componentAttributeEventMutation';
import { IapComponentAttributeEvent } from '../domain/iapComponentAttributeEvent';
import ApolloConst from '../../../../common/domain/constantes/Apollo/ApolloConst';
import HelperUtils from '../../../../common/infrastructure/funciones/HelperUtils';



@injectable()
export class ComponentAttributeEventApolloClientRepository implements IComponentAttributeEventRepository {
  private apolloClient : MyApolloClient
  private clientId: String
  constructor (apolloInstance: MyApolloClient, clientId = ApolloConst.DEFAULT) {
    this.apolloClient = apolloInstance
    this.clientId = clientId
  }
  
  

  async update (dataInput: IapComponentAttributeEvent): (Promise<boolean>) {
    return new Promise<boolean>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(UPDATE,{data:dataInput}, this.clientId)    

      watch(result, (value: any) => {
        
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.componentAttributeEventMutation)
        }
        catch(e) {
          reject()
        }
      });

    });
  }

  async add (dataInput: IapComponentAttributeEvent): (Promise<boolean>) {
    return new Promise<boolean>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(ADD,{data:dataInput}, this.clientId)    

      watch(result, (value: any) => {
        
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.componentAttributeEventMutation)
        }
        catch(e) {
          reject()
        }
      });

    });
  }

  async getAll (maxregs: number | undefined): (Promise<IapComponentAttributeEvent[]>) {
    return new Promise<IapComponentAttributeEvent[]>(async (resolve, reject) => {
      /*const result = apolloClient.executeQuery(GET_ALL_COMPONENTS, { maxregs: maxregs })
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.componentAttributeEventQuery.getAll)
        }
        catch(e) {
          reject()
        }
      });*/
    });
  }

  async getById (id: number): (Promise<IapComponentAttributeEvent>) {
    return new Promise<IapComponentAttributeEvent>(async (resolve, reject) => {
     /* const result = apolloClient.executeQuery(GET_COMPONENT_BY_ID, { id: id })
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.componentAttributeEventQuery.getById)
        }
        catch(e) {
          reject()
        }
      });*/
    });
  }


}


